import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RecoverPasswordRequest } from '../../../core/models/auth/auth.request';
import { AuthService } from '../../../core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-recover-password',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './recover-password.component.html',
  styleUrl: './recover-password.component.scss'
})
export class RecoverPasswordComponent {
  form: FormGroup;
  errorMessage: string | null = null;

  constructor(private router: Router, private fb: FormBuilder, private authService: AuthService) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
    
  }

  get registerEmail() {
    return this.form.get('email');
  }

  verificarCorreo() {
    if (this.form?.valid) {
      let param = this.form?.value as RecoverPasswordRequest;

      this.authService.recoverPassword(param)
        .subscribe({
          next: async (res: any) => {
            if (res.success) {
              console.log('res', res);
              Swal.fire({
                title: '¡Instrucciones enviadas!',
                html: `
                  <p>${res.message}</p>
                  <p style="font-size: 0.9em; color: gray; margin-top: 10px;">
                    ¿No recibiste el mensaje? Verifica en el filtro de spam o inténtalo con otro correo electrónico.
                  </p>
                `,
                confirmButtonText: 'Continuar',
                customClass: {
                  confirmButton: 'alert-confirmButton'
              }
              });
            } else {
              this.errorMessage = res.message;
            }
          },
          error: err => {
            console.log('err', err);
          }
        });
    }
  }

  navigateToRegister() {
    this.router.navigate(['/auth']);
  }
}
